import React from "react";
import Auth from "../../configs/Auth";
import LoggedInLayout from "../../layouts/LoggedInLayout";
import GuestLayout from "../../layouts/GuestLayout";

const NotFoundRoute = ({ children }) => {
  if (Auth.isAuthenticated()) {
    return <LoggedInLayout>{children}</LoggedInLayout>;
  }

  return <GuestLayout>{children}</GuestLayout>;
};

export default NotFoundRoute;
